import { servicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL } from '../constants';

export function useEnvHealthApiTriggeredBroadcasts(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  enabled = true,
) {
  return servicesQuery.getEnvHealthApiTriggeredBroadcasts.useQuery({
    queryKey: ['env-health-api-triggered-broadcasts', workspaceId, simulate],
    queryData: { params: { environment_id: workspaceId }, query: { simulate } },
    refetchInterval: WORKSPACE_HEALTH_REFETCH_INTERVAL,
    enabled: workspaceId > 0 && enabled,
  });
}
